import PlatformSelect from './PlatformSelect'

export default PlatformSelect
